module.exports = __webpack_public_path__ + "static/img/4.3fdd980.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/4/2/eng/4.png
// module id = EL3R
// module chunks = 0